import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import HorizontalLogo from "../../../public/logo/horizontal.svg";
import S from "./styles.module.scss";

export interface StatusAction {
  label: string;
  icon?: LucideIcon;
  variant?: "primary" | "secondary";
  to?: string;
  onClick?: () => void;
}

interface StatusScreenProps {
  visual: ReactNode;
  title: string;
  description: ReactNode;
  actions?: StatusAction[];
  fullscreen?: boolean;
}

const renderAction = ({
  label,
  icon: Icon,
  variant = "primary",
  to,
  onClick,
}: StatusAction) => {
  const content = (
    <>
      {Icon && <Icon size={18} aria-hidden="true" />}
      {label}
    </>
  );
  const className = `${S.action} ${S[variant]}`;

  return to ? (
    <Link key={label} to={to} className={className}>
      {content}
    </Link>
  ) : (
    <button key={label} type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );
};

const StatusScreen = ({
  visual,
  title,
  description,
  actions = [],
  fullscreen = false,
}: StatusScreenProps) => (
  <main className={`${S.screen} ${fullscreen ? S.fullscreen : S.inline}`}>
    {fullscreen && (
      <HorizontalLogo className={S.logo} role="img" aria-label="Genialogic" />
    )}
    <section className={S.content} aria-labelledby="status-screen-title">
      <div className={S.visual} aria-hidden="true">
        {visual}
      </div>
      <h1 id="status-screen-title" className={S.title}>
        {title}
      </h1>
      <p className={S.description}>{description}</p>
      {actions.length > 0 && (
        <div className={S.actions}>{actions.map(renderAction)}</div>
      )}
    </section>
  </main>
);

export default StatusScreen;

